<template>
<div class="article-wrap">
  <div class="main-1 container clearfix">
    <main class="left">
      <div class="article-ads" v-if="$store.state.adList['leftHeadNormal']">
        <nuxt-link :to="`/article/detail/${$store.state.adList['leftHeadNormal'][0].link}`" target="_blank">
          <section class="headline_wrap" :style="{ 'background-image': 'url(' + $store.state.adList['leftHeadNormal'][0].image + ')' }">
            <div class="headline">
              <p class="title clearfix">
                <span class="left">头条</span>
                <span class="left">{{ $store.state.adList['leftHeadNormal'][0].title }}</span>
              </p>
              <p class="detail">{{ $store.state.adList['leftHeadNormal'][0].desc }}</p>
            </div>
          </section>
        </nuxt-link>
        <section class="yf-component-list_wrap clearfix">
          <div class="item left" v-for="item of $store.state.adList['leftHeadNoNormal']" :key="item.id">
            <p class="text_wrap ellipsis">
              <i></i><nuxt-link class="teacher" target="_blank" :to="`/article/list/${item.userid}`">{{ item.username }}</nuxt-link> | <nuxt-link target="_blank" :to="`/article/detail/${item.link}`" class="article" :title="item.title">{{ item.title }}</nuxt-link>
            </p>
          </div>
        </section>
      </div>
      <!-- 最新文章 -->
      <div class="article_menu clearfix">
        <span class="left">最新文章</span>
        <nuxt-link to="/article/list" class="right">查看更多 &raquo;</nuxt-link>
      </div>
      <div class="article-list">
        <YList :data="list" />
      </div>
      <!-- 各类资讯 -->
      <!-- <section class="news">
        <div class="news-nav clearfix">
          <span class="underline"></span>
          <span class="left">最新资讯</span>
          <nuxt-link
            :to="`/article/list?irSid=${item.id}`"
            v-for="item of newsNav"
            :key="item.id"
            class="left"
          >{{ item.title }}</nuxt-link>
        </div>
        <div class="yf-news-list">
          <section class="news-list-content" v-for="item of infos" :key="item.irSid">
            <div class="info clearfix">
              <h3 class="left ellipsis"><nuxt-link :to="`article/detail/${item.irSid}?irSid=1`">[{{ item.irCatalog }}] {{ item.irUrltitle }}</nuxt-link></h3>
              <time class="right">{{ item.irLasttime }}</time>
            </div>
            <p class="intro">股市有风险，入市需谨慎。网站所有证券股票相关的信息，仅代表用户个人的立场和观点，不构成投资建议和买卖信息，仅供投资者学习和交流，据此入市，风险自负!</p>
          </section>
        </div>
      </section> -->
    </main>

    <aside class="right">
      <section class="yf-recommend author">
        <p class="title">推荐作者</p>
        <nuxt-link :to="`/article/list/${item.relationData.id}`" class="item clearfix" v-for="item of $store.state.adList['rightTeacher']" :key="item.id">
          <div class="item_left left">
            <img v-lazy="isSupportWebp(item.relationData.avatar)" :alt="item.relationData.userName"/>
          </div>
          <div class="item_right right">
            <p class="name_wrap clearfix">
              <span class="left">{{ item.relationData.userName }}</span>
              <span class="right">
                <i>{{ item.relationData.articleTotal }}</i>文章
              </span>
            </p>
            <p class="detail ellipsis">{{ item.relationData.sign }}</p>
          </div>
        </nuxt-link>
      </section>
      <section class="yf-recommend article" v-if="hotArticles.length">
        <p class="title" style="padding-bottom: 10px;">热门文章</p>
        <div class="item" :class="{ bg: index === 0 }" v-for="(item, index) of hotArticles" :key="item.id">
          <p class="text_wrap ellipsis">
            <i v-if="!!index"></i>
            <nuxt-link :to="`/article/list/${item.userId}`">{{ item.userName }}</nuxt-link>| <nuxt-link :to="`/article/detail/${item.id}`" class="detail">{{ item.title }}</nuxt-link>
          </p>
          <p class="time_wrap yf-text_14">
            <span class="time">{{ item.createAt }}</span>
            <span class="number right">阅读<i>{{ item.viewCount }}</i></span>
          </p>
        </div>
      </section>
      <section class="yf-recommend author">
        <p class="title">热门订阅</p>
        <nuxt-link :to="`/article/list/${item.relationData.id}`" class="item clearfix" v-for="item of $store.state.adList['rightTakeTeacher']" :key="item.id">
          <div class="item_left left">
            <img v-lazy="isSupportWebp(item.relationData.avatar)" :alt="item.relationData.userName"/>
          </div>
          <div class="item_right right">
            <p class="name_wrap clearfix">
              <span class="left">{{ item.relationData.userName }}</span>
              <span class="right">
                <i>{{ item.relationData.articleTotal }}</i>文章
              </span>
            </p>
            <p class="detail ellipsis">{{ item.relationData.sign }}</p>
          </div>
        </nuxt-link>
      </section>
      <section class="yf-recommend news" v-if="news.length">
        <p class="title">
          <span>快讯</span>
          <nuxt-link tag="span" to="/news">查看更多 &raquo;</nuxt-link>
        </p>
        <div class="news-item">
          <p class="info clearfix" v-for="item of news" :key="item.irSid">
            <span class="left">{{ item.irLasttime.split(' ')[1].slice(0, 5) }}</span>
            <nuxt-link :to="`/news/${item.irSid}`" class="left ellipsis" target="_blank">{{ item.irUrltitle }}</nuxt-link>
          </p>
        </div>
      </section>
      <section class="yf-recommend author" v-if="$store.state.adList['hotRoom']">
        <p class="title">
          <span>热门</span>
          <nuxt-link tag="span" to="/room">查看更多 &raquo;</nuxt-link>
        </p>
        <nuxt-link :to="`/room/${item.relationData.id}`" class="item clearfix live" v-for="item of $store.state.adList['hotRoom'].slice(0, 4)" :key="item.id">
          <div class="item_left left">
            <img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName"/>
          </div>
          <div class="item_right right">
            <p class="name_wrap clearfix">
              <span class="left">{{ item.relationData.userName }}</span>
              <span class="right" :class="{ 'yf-status-open': item.relationData.status === 11, 'yf-status-pause': item.relationData.status === 12, 'yf-status-close': item.relationData.status === 21 || item.relationData.status === undefined }"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.status | famousRoomStatus }}</nuxt-link></span>
            </p>
            <p class="detail ellipsis">{{ item.relationData.introduce }}</p>
          </div>
        </nuxt-link>
      </section>
    </aside>
  </div>
</div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'
import { famousRoomStatus } from '~/utils/Filters'
import YList from '@/components/articles/List'

export default {
  mixins: [Webp],
  name: 'article-index',
  async asyncData ({ $axios }) {
    let apiParams = {
      page: 1,
      num: 11,
      service: 1
    }

    let { list } = await $axios._get('/Article/List', apiParams)

    return {
      list
    }
  },
  head () {
    return {
      title: '财经看点_名师博文_一富财经_投资者教育平台_为股民创造卓越的学习环境',
      meta: [
        { hid: 'keywords', name: 'keywords', content: '股市文章_股票资讯_股市早评_大盘预测_证券_财经要闻_名师博文' },
      ]
    }
  },
  data () {
    return {
      mark: 0,
      newsNav: [
        { id: 1, title: '证券' },
        { id: 2, title: '国内财经' },
        { id: 3, title: '新股动态' },
        { id: 4, title: '港股' },
        { id: 5, title: '公司要闻' }
      ],
      // 资讯
      infos: [],
      // 热门文章
      hotArticles: [],
      // 快讯
      news: [],
      timer: null
    }
  },
  mounted () {
    this.$store.dispatch('getAd', ['leftHeadNormal', 'leftHeadNoNormal', 'rightTeacher', 'rightTakeTeacher', 'hotRoom'])
    // 获取最新资讯
    this.$axios._get('/Information/List').then(res => {
      this.infos = res
    })

    // 快讯每五分钟更新一次
    this.getNews()
    this.timer = setInterval(() => {
      this.getNews()
    }, 1000 * 300)
    // 热门文章数据，暂时通过获取文章列表，后需要改成广告位再改
    this.$axios._get('/Article/List', { page: 1, num: 5, order: 'hot' }).then(data => {
      this.hotArticles = data.list
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getNews () {
      // 获取快讯
      this.$axios._get('/Information/OtherList', { type: 6, page: 1, num: 5 }).then(res => {
        this.news = res.list
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  filters: {
    famousRoomStatus
  },
  computed: {
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    }
  },
  components: {
    YList
  }
}
</script>
